<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="section-title">{{ $t("offertypes") }}</div>
      <router-link
        v-if="$can('create', 'Offer Types')"
        class="btn-blue"
        to="add-offer-Types"
        >{{ $t("add") }}</router-link
      >
    </div>
    <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <FilterByStatusDropdown
          :onSelect="(filterIsActive) => getOfferList(filterIsActive)"
        />
        <div class="mx-2">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- {{ $t("viewing") }}&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;{{ $t("of") }}&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>
    <div>
      <table class="list-view-table">
        <thead>
          <tr>
            <th class="text-left">
              <span class="pr-3">{{ $tc("status", 2) }}</span>
            </th>
            <th>
              <img
                v-if="this.columnName != 'mkt_title'"
                @click="onSortValue('mkt_title', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('mkt_title', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('mkt_title', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $t("marketingtype") }}
            </th>
            <th>
              <img
                v-if="this.columnName != 'ot_offer_type'"
                @click="onSortValue('ot_offer_type', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('ot_offer_type', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('ot_offer_type', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $t("offer") }}
            </th>
          </tr>
        </thead>
        <tbody v-if="offername.length > 0">
          <tr v-for="(offer, offerIndex) in offername" :key="offerIndex">
            <!-- <td>
              <div class="d-flex align-items-center justify-content-end">
                <StatusDot
                  :status="
                    offer.ot_is_active === 'Y'
                      ? 'active'
                      : offer.ot_is_active === 'N' && 'inactive'
                  "
                />
                <b-dropdown right variant="edit" class="ml-4">
                  <b-dropdown-item
                    v-if="$can('update', 'Offer Types')"
                    v-on:click="onEditOffer(offer)"
                  >
                    <span class="edit-pen"></span>
                    {{ $t("edit") }}
                  </b-dropdown-item>
                  <b-dropdown-item v-on:click="onViewOffer(offer)">
                    <span class="icon-eye"></span>
                    {{ $t("view") }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </td> -->
            <td>
              <div class="d-flex align-items-center justify-content-start">
                <StatusDot
                  :status="
                    offer.ot_is_active === 'Y'
                      ? 'active'
                      : offer.ot_is_active === 'N' && 'inactive'
                  "
                />
                <div class="ml-2" v-b-tooltip="'Edit Offer'" tabindex="0">
                  <i
                    v-if="$can('update', 'Offer Types')"
                    class="edit-pen icon blue-icon cursor-pointer"
                    @click.prevent.stop="onEditOffer(offer)"
                  ></i>
                </div>
                <div class="ml-2" v-b-tooltip="'View Offer'" tabindex="0">
                  <i
                    class="icon-eye blue-icon cursor-pointer"
                    @click.prevent.stop="onViewOffer(offer)"
                  ></i>
                </div>
              </div>
            </td>
            <td>{{ offer.mkt_title }}</td>
            <td>{{ offer.ot_offer_type }}</td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="3">
              <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div>
            </td>
          </tr>
        </tbody>
      </table>
      <b-pagination
        v-if="offername.length > 0"
        v-model="currentPage"
        :total-rows="rows"
        @change="onChangePagination($event)"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import MarketingService from "@/services/MarketingService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
  },
  data() {
    return {
      ot_id: "",
      ot_offer_type: "",
      marketing_type_id: "",
      mkt_id: "",
      mkt_title: "",
      offername: [],
      // institutes: [],
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      viewingnumbers: [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ],

      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",
    };
  },
  beforeMount() {
    this.getOfferList();
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  methods: {
    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getOfferList();
    },
    getOfferList: function (filterIsActive = "Y") {
      this.offername = [];
      MarketingService.getAllOfferType(
        this.perPage,
        this.currentPage,
        this.columnName,
        this.orderby,
        filterIsActive
      ).then((response) => {
        const { data } = response;

        if (data && data.Records.length > 0) {
          this.offername = data.Records;
          this.rows = data.totalCount;
        }
      });
    },
    onViewOffer: function (offer) {
      this.$router.push({
        path: "/marketing/view-offer-Types",
        query: { ot_id: offer.ot_id },
      });
    },
    onEditOffer: function (offer) {
      this.$router.push({
        path: "/marketing/edit-offer-Types",
        query: { ot_id: offer.ot_id },
      });
    },

    onChangePagination: function (event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getOfferList();
      } else {
        this.currentPage = event;
        this.getOfferList();
      }
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        this.selectedvalue = event;
        this.perPage = event;
        this.onChangePagination();
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/OfferComponents/offerTypes.vue